import React from "react";

export default function ErrorPopup({ errors = [], onClose, show }) {
  if (!show || errors.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-md p-6 text-center animate-fadeIn">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Form Errors</h2>
        <ul className="text-left text-gray-700 mb-6 list-disc list-inside space-y-1">
          {errors.map((err, index) => (
            <li key={index}>{err}</li>
          ))}
        </ul>
        <button
          onClick={onClose}
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors duration-200"
        >
          Close
        </button>
      </div>
    </div>
  );
}
